import { render, staticRenderFns } from "./ChangeTelComplete.vue?vue&type=template&id=38563a24&"
import script from "./ChangeTelComplete.vue?vue&type=script&lang=js&"
export * from "./ChangeTelComplete.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/content.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports